export const PHONE_NUMBER_LENGTH_US = 10;

const parenthesizeAreaCode = (phoneNumber) => {
  const areaCode = phoneNumber.substr(0, 3);
  const first = phoneNumber.substr(3, 3);
  const second = phoneNumber.substr(6, 4);
  return `(${areaCode}) ${first}-${second}`;
};

export const stripNonNumerals = (stringToStrip) => {
  const strArr = stringToStrip.split('');
  return strArr.reduce((acc, char) => {
    const asInt = parseInt(char, 10);
    if (typeof asInt === 'number' && !Number.isNaN(asInt)) {
      return acc + char;
    }
    return acc;
  }, '');
};

export const reformatPhoneNumber = (phoneNumber) => {
  const stringPhoneNumber = `${phoneNumber}`;

  const stripped = stripNonNumerals(stringPhoneNumber);
  if (stripped.length === PHONE_NUMBER_LENGTH_US) {
    return parenthesizeAreaCode(stripped);
  }
  return stringPhoneNumber;
};
